module.exports = __webpack_public_path__ + "media/images/philanthropy-logos/logo-alpha-phi-deb4afc9410821f991fb077daaf8b492.svg";